import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SideBarService } from 'src/app/services/side-bar.service';
import { FilterProperty, ListFilterService } from '../list-filter-service';

@Component({
  selector: 'app-multiple-property-filter',
  templateUrl: './multiple-property-filter.component.html'
})
export class MultiplePropertyFilterComponent {
  @Input() properties: FilterProperty[];
  @Output() closeRequested = new EventEmitter();

  @Input()
  isCloseButtonVisible = true;

  @Input()
  mode: 'List' | 'Search' = 'List';

  get isThereAnyItem() {
    return this.#filterService && this.#filterService.items
      && this.#filterService.items.length > 0;
  }

  #filterService: ListFilterService;
  get filterService(): ListFilterService {
    return this.#filterService;
  }
  @Input()
  set filterService(value: ListFilterService) {
    if (value === this.#filterService) return;
    this.#filterService = value;
  }
  @Input() itemCount: number;
  @Output() filterChanged = new EventEmitter();

  constructor(public sidebar: SideBarService) {
    console.log('multiple-property-filter created');
  }

  emitFilterChanged() {
    console.log('multifilter',this.properties);
    this.filterChanged.emit();
  }

  close() {
    this.closeRequested.emit();
  }

  clear() {
    this.#filterService.clear();
    this.filterChanged.emit();
  }

  get isFiltered(): boolean {
    return this.#filterService && this.#filterService.isFiltered;
  }
}
